import { filter, find, map, sortBy, uniq } from "lodash";
import { AiccLessonReviewScript, AiccReviewScript } from "types/model/aiccLearningAssets";
import { LESSON_SCRIPT_OPTION } from "../configs";

export const levelValues = (lessons: AiccLessonReviewScript[]) => sortBy(uniq(map(lessons, "level")));

export const lessonValues = (lessons: AiccLessonReviewScript[], level: number) =>
  sortBy(uniq(map(filter(lessons, { level }), "lesson")));

export const lessonScripts = (lessons: AiccLessonReviewScript[], level: number, lesson: number): AiccReviewScript[] =>
  sortBy(find(lessons, { level, lesson })?.scripts ?? [], "scriptIndex");

export const scriptOptions = (scripts: AiccReviewScript[]) =>
  map(scripts, ({ scriptIndex, title }) => ({
    value: scriptIndex,
    label: LESSON_SCRIPT_OPTION(scriptIndex, title),
  }));

export const selectedScript = (
  lessons: AiccLessonReviewScript[],
  level: number,
  lesson: number,
  scriptIndex: number
): AiccReviewScript | undefined => find(lessonScripts(lessons, level, lesson), { scriptIndex });
